import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { makeStyles } from "@material-ui/core/styles"
import { Typography, Button, Grid } from "@material-ui/core"
import { useHistory } from "react-router-dom"
import { PageNotFoundSvg } from "../components/icons"
import { theme } from "../themes"
import { ROUTES } from "../utils"

const useStyles = makeStyles((theme) => ({
	root: {
		background: theme?.palette.background.paper,
		height: "100vh",
		padding: 0,
		display: "flex",
	},
}))

const PageNotFound = () => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const history = useHistory()
	const [t] = useTranslation("global")

	return (
		<>
			<Grid className={classes.root} container direction="row">
				<Grid container style={{ alignItems: "center", justifyContent: "center" }}>
					<Grid item style={{ display: "flex", padding: 0, alignItems: "center" }} xs={7} className={classes.header}>
						<Grid item xs={8} style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
							<PageNotFoundSvg />
						</Grid>
						<Grid item xs={4}>
							<Typography style={{ ...theme.typography.h1, fontWeight: "bold", paddingBottom: "20px" }}>
								{t("pageNotFound.pageNotFoundTitle")}
							</Typography>
							<Typography style={{ ...theme.typography.h4, fontWeight: "400", paddingBottom: "40px" }}>
								{t("pageNotFound.pageNotFoundDescription")}
							</Typography>
							<Button
								size="medium"
								style={{ cursor: "pointer", textTransform: "capitalize" }}
								onClick={() => {
									history.push(ROUTES.DASHBOARD)
								}}
								variant="contained"
								color="primary"
							>
								{t("pageNotFound.goBack")}
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</>
	)
}

export default PageNotFound
